//berubah
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";

const JumlahNilai = ({ mapel }) => {
  const [nilai, setNilai] = useState([]);
  const [persen, setPersen] = useState(null);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [datakepsek, setDataKepsek] = useState([]);
  const [sekolah, setSekolah] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    tahun: "",
    kelas: "",
    rombel: "",
    semester: "",
  });
  const [dataTerakhir, setDataTerakhir] = useState(null);
  const [tabelVisible, setTabelVisible] = useState(false);

  const kelasOptions = ["1", "2", "3", "4", "5", "6"];
  const rombelOptions = ["A", "B", "C", "D"];
  const semesterOptions = ["1", "2"];

  // ================= AMBIL PROFILE =================
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/auth/profile`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        setUser(res.data);
      } catch (err) {
        console.error("Gagal mengambil profile", err);
      }
    };

    fetchProfile();
  }, []);

  /* ================= KEPSEK ================= */
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}api/auth/user-images-and-roles`)
      .then((res) =>
        setDataKepsek(res.data.filter((u) => u.jabatan === "Kepala Sekolah")),
      )
      .catch(() => "Gagal mengambil data kepala sekolah");
  }, []);

  useEffect(() => {
    const fetchNilai = async () => {
      try {
        const token = localStorage.getItem("token");
        const decoded = jwtDecode(token);
        const userId = decoded.user.id;

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const [nilaiResponse, persenResponse] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_URL}api/nilai/mapel/${mapel}/createdBy/${userId}`,
            config,
          ),
          axios.get(
            `${process.env.REACT_APP_API_URL}api/persen/mapel/${mapel}/user/${userId}`,
            config,
          ),
        ]);

        // Setelah mendapatkan respons dari API, filter nilai berdasarkan filterOptions
        const filteredNilaiResponse = nilaiResponse.data.filter(
          (item) =>
            (!filterOptions.tahun || item.tahun === filterOptions.tahun) &&
            (!filterOptions.kelas || item.kelas === filterOptions.kelas) &&
            (!filterOptions.rombel || item.rombel === filterOptions.rombel) &&
            (!filterOptions.semester ||
              item.semester === filterOptions.semester),
        );

        setNilai(filteredNilaiResponse);
        setPersen(persenResponse.data);
      } catch (error) {
        setError("Error fetching data: " + error.message);
      }
    };

    if (mapel) {
      fetchNilai();
    }
  }, [mapel, filterOptions]);
  const getTanggalIndonesia = () => {
    const now = new Date();

    const bulan = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    return `${now.getDate()} ${bulan[now.getMonth()]} ${now.getFullYear()}`;
  };

  /* ================= DATA SEKOLAH ================= */
  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/datasekolah/all`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setSekolah(res.data || []);
      } catch (err) {
        console.error("Gagal mengambil data sekolah", err);
      }
    };
    fetchSchoolData();
  }, []);

  const uniqueJenis = [...new Set(nilai.map((data) => data.jenis))];

  const consolidatedNilai = nilai.reduce((acc, data) => {
    data.nilai.forEach((nilaiItem) => {
      if (!acc[nilaiItem.studentId]) {
        acc[nilaiItem.studentId] = {
          studentId: nilaiItem.studentId,
          name: nilaiItem.name,
          nilai: {},
          kelas: data.kelas,
          rombel: data.rombel,
          tahun: data.tahun,
          semester: data.semester,
        };
      }
      if (!acc[nilaiItem.studentId].nilai[data.jenis]) {
        acc[nilaiItem.studentId].nilai[data.jenis] = [];
      }
      acc[nilaiItem.studentId].nilai[data.jenis].push(nilaiItem.nilaiTotal);
    });
    return acc;
  }, {});

  const calculateFinalScore = (averageNilai, jenis) => {
    if (!persen || !persen[jenis]) return 0;
    const percentage = persen[jenis] / 100;
    return averageNilai * percentage;
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterOptions({ ...filterOptions, [name]: value });
  };

  const applyFilters = (data) => {
    const { tahun, kelas, rombel, semester } = filterOptions;

    // Pastikan tahun, kelas, rombel, dan semester tidak kosong sebelum memfilter
    if (!tahun || !kelas || !rombel || !semester) {
      return [];
    }

    const filteredData = data.filter((item) => {
      return (
        (!tahun || item.tahun === tahun) &&
        (!kelas || item.kelas === kelas) &&
        (!rombel || item.rombel === rombel) &&
        (!semester || item.semester === semester)
      );
    });

    return filteredData;
  };

  const filteredNilai = applyFilters(Object.values(consolidatedNilai));

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const userId = decoded.user.id;

      const nilaiFinalData = filteredNilai.map((student) => ({
        studentId: student.studentId,
        name: student.name,
        finalScore: uniqueJenis.reduce((total, jenis) => {
          const totalNilai = student.nilai[jenis]
            ? student.nilai[jenis].reduce((total, n) => total + n, 0)
            : 0;
          const countNilai = student.nilai[jenis]
            ? student.nilai[jenis].length
            : 0;
          const averageNilai = countNilai ? totalNilai / countNilai : 0;
          const finalScore = calculateFinalScore(averageNilai, jenis);
          return total + finalScore;
        }, 0),
      }));

      const data = {
        mapel,
        kelas: filterOptions.kelas,
        rombel: filterOptions.rombel,
        tahun: filterOptions.tahun,
        semester: filterOptions.semester,
        createdBy: userId,
        nilai: nilaiFinalData,
      };

      if (JSON.stringify(data) === JSON.stringify(dataTerakhir)) {
        alert("Data sudah pernah dikirim sebelumnya.");
        return;
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      await axios.post(
        `${process.env.REACT_APP_API_URL}api/nilaiFinal`,
        data,
        config,
      );
      setDataTerakhir(data);
      alert("Data berhasil dikirim");
    } catch (error) {
      alert(
        "Data telah tersedia, lakukan penghapusan data terlebih dahulu agar dapat memperbaharui data",
      );
    }
  };

  const handleDeleteData = async () => {
    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const userId = decoded.user.id;

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const { tahun, kelas, rombel, semester } = filterOptions;

      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/nilaiFinal/mapel/${mapel}/kelas/${kelas}/rombel/${rombel}/tahun/${tahun}/semester/${semester}/createdBy/${userId}`,
        config,
      );

      setDataTerakhir(null);
      alert("Data berhasil dihapus");
    } catch (error) {
      alert("Error deleting data: " + error.message);
    }
  };

  const handleDownloadPDF = async () => {
    const element = document.getElementById("Print-area");
    if (!element) return;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("l", "mm", "a4"); // portrait sama seperti Absen
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let position = 0;
    let heightLeft = imgHeight;

    while (heightLeft > 0) {
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      position -= pageHeight;
      if (heightLeft > 0) pdf.addPage();
    }

    pdf.save(
      `Nilai-${mapel}-${filterOptions.kelas}${filterOptions.rombel}.pdf`,
    );
  };

  // Memastikan bahwa tabel hanya muncul jika semua filter telah diisi
  useEffect(() => {
    if (
      filterOptions.tahun &&
      filterOptions.kelas &&
      filterOptions.rombel &&
      filterOptions.semester
    ) {
      setTabelVisible(true);
    } else {
      setTabelVisible(false);
    }
  }, [mapel, filterOptions]);
  const excludedPersenKeys = ["_id", "createdBy", "mapel", "__v"];

  return (
    <div className="container mx-auto p-4">
      <div className="grid mb-4 bg-white p-5 gap-y-4 rounded-lg drop-shadow-lg mx-3 md:mx-0">
        {/* Judul */}
        <h2 className="text-2xl font-bold mb-4 text-center">Nilai</h2>

        {/* Error Message */}
        {error && <p className="text-red-500 text-center">{error}</p>}

        {/* Filter Inputs */}
        <div className="grid gap-y-4">
          {/* Tahun */}
          <div className="flex items-center">
            <label className="w-1/4 font-medium">Tahun:</label>
            <input
              type="text"
              name="tahun"
              value={filterOptions.tahun}
              onChange={handleFilterChange}
              className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
            />
          </div>

          {/* Kelas */}
          <div className="flex items-center">
            <label className="w-1/4 font-medium">Kelas:</label>
            <select
              name="kelas"
              value={filterOptions.kelas}
              onChange={handleFilterChange}
              className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
            >
              <option value="">Pilih kelas</option>
              {kelasOptions.map((kelas, index) => (
                <option key={index} value={kelas}>
                  {kelas}
                </option>
              ))}
            </select>
          </div>

          {/* Rombel */}
          <div className="flex items-center">
            <label className="w-1/4 font-medium">Rombel:</label>
            <select
              name="rombel"
              value={filterOptions.rombel}
              onChange={handleFilterChange}
              className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
            >
              <option value="">Pilih rombel</option>
              {rombelOptions.map((rombel, index) => (
                <option key={index} value={rombel}>
                  {rombel}
                </option>
              ))}
            </select>
          </div>

          {/* Semester */}
          <div className="flex items-center">
            <label className="w-1/4 font-medium">Semester:</label>
            <select
              name="semester"
              value={filterOptions.semester}
              onChange={handleFilterChange}
              className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
            >
              <option value="">Pilih semester</option>
              {semesterOptions.map((semester, index) => (
                <option key={index} value={semester}>
                  {semester}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto overflow-y-auto max-w-[400px] max-h-[600px] sm:max-w-[600px] md:max-w-full md:max-h-[600px] shadow-lg mx-4 ">
        {tabelVisible && (
          <table className="min-w-full bg-white border border-gray-300  ">
            <thead className="bg-gray-200">
              <tr>
                <th className="py-2 px-4 border border-gray-300">Nama</th>
                {uniqueJenis.map((jenis, index) => (
                  <th key={index} className="py-2 px-4 border border-gray-300">
                    {jenis}
                  </th>
                ))}
                <th className="py-2 px-4 border border-gray-300">
                  Final Score
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredNilai.map((student, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="py-2 px-4 border border-gray-300">
                    {student.name}
                  </td>
                  {uniqueJenis.map((jenis, jIndex) => {
                    const totalNilai = student.nilai[jenis]
                      ? student.nilai[jenis].reduce((total, n) => total + n, 0)
                      : 0;
                    const countNilai = student.nilai[jenis]
                      ? student.nilai[jenis].length
                      : 0;
                    const averageNilai = countNilai
                      ? totalNilai / countNilai
                      : 0;
                    const finalScore = calculateFinalScore(averageNilai, jenis);
                    return (
                      <td
                        key={jIndex}
                        className="py-2 px-4 border border-gray-300"
                      >
                        {student.nilai[jenis] ? (
                          <div className="flex flex-col">
                            {student.nilai[jenis].map((nilai, kIndex) => (
                              <span
                                key={kIndex}
                                className="border-b border-gray-300 py-1"
                              >
                                {nilai}
                              </span>
                            ))}
                            <span className="font-bold mt-2">
                              Total: {totalNilai} | Rata-rata: {averageNilai} |
                              Final: {finalScore}
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    );
                  })}
                  <td className="py-2 px-4 border border-gray-300">
                    {uniqueJenis.reduce((total, jenis) => {
                      const totalNilai = student.nilai[jenis]
                        ? student.nilai[jenis].reduce(
                            (total, n) => total + n,
                            0,
                          )
                        : 0;
                      const countNilai = student.nilai[jenis]
                        ? student.nilai[jenis].length
                        : 0;
                      const averageNilai = countNilai
                        ? totalNilai / countNilai
                        : 0;
                      const finalScore = calculateFinalScore(
                        averageNilai,
                        jenis,
                      );
                      return total + finalScore;
                    }, 0)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div
        id="Print-area"
        className="bg-white px-4 py-5 absolute -left-[9999px] top-0 w-[794px] text-sm"
      >
        <div className="flex justify-center font-bold mb-2 ">
          <p>Daftar Nilai {mapel}</p>
        </div>
        <div className="mb-4 flex justify-between text-[12px] gap-y-1 px-4">
          <div>
            <div className="flex gap-2">
              <span className="font-semibold w-20">Kelas</span>
              <span>:</span>
              <span>{filterOptions.kelas}</span>
            </div>
            <div className="flex gap-2">
              <span className="font-semibold w-20">Rombel</span>
              <span>:</span>
              <span>{filterOptions.rombel}</span>
            </div>
          </div>
          <div>
            <div className="flex gap-2">
              <span className="font-semibold w-20">Tahun</span>
              <span>:</span>
              <span>{filterOptions.tahun}</span>
            </div>

            <div className="flex gap-2">
              <span className="font-semibold w-20">Semester</span>
              <span>:</span>
              <span>{filterOptions.semester}</span>
            </div>
          </div>
        </div>
        {tabelVisible && (
          <div className="overflow-x-auto rounded-lg border border-gray-300 text-[12px]">
            <table className="min-w-full text-sm text-left bg-white">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-2 pb-3 border text-[12px]">Nama Siswa</th>

                  {uniqueJenis.map((jenis, index) => (
                    <th
                      key={index}
                      className="px-2 pb-3 border text-center text-[12px] whitespace-nowrap"
                    >
                      {jenis}
                    </th>
                  ))}

                  <th className="px-2 pb-3 border text-center text-[12px] whitespace-nowrap">
                    Rata - Rata
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredNilai.map((student, index) => (
                  <tr
                    key={index}
                    className="hover:bg-blue-50 transition-colors"
                  >
                    <td className="px-2 pb-2 border font-medium text-[12px]">
                      {student.name}
                    </td>

                    {uniqueJenis.map((jenis, jIndex) => (
                      <td key={jIndex} className="px-2 pb-2 border text-center">
                        {student.nilai[jenis] ? (
                          <div className="flex flex-wrap justify-center gap-2">
                            {student.nilai[jenis].map((nilai, kIndex) => (
                              <span
                                key={kIndex}
                                className="px-2 py-1 bg-gray-100 rounded text-xs font-medium text-[12px]"
                              >
                                {nilai}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </td>
                    ))}

                    <td className="px-2 pb-2 border text-center text-[12px]">
                      {(() => {
                        const hasilAsli = uniqueJenis.reduce((total, jenis) => {
                          const totalNilai = student.nilai[jenis]
                            ? student.nilai[jenis].reduce(
                                (total, n) => total + n,
                                0,
                              )
                            : 0;

                          const countNilai = student.nilai[jenis]
                            ? student.nilai[jenis].length
                            : 0;

                          const averageNilai = countNilai
                            ? totalNilai / countNilai
                            : 0;

                          const finalScore = calculateFinalScore(
                            averageNilai,
                            jenis,
                          );

                          return total + finalScore;
                        }, 0);

                        const hasilBulat = Math.round(hasilAsli);

                        return (
                          <div className="flex justify-center gap-x-2">
                            <div className="text-[12px] text-gray-500">
                              ({hasilAsli.toFixed(3)})
                            </div>{" "}
                            <div className="text-blue-600 font-semibold text-[12px]">
                              = {hasilBulat}
                            </div>
                          </div>
                        );
                      })()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}{" "}
        {persen && (
          <div className="mt-6 px-4">
            <h3 className="font-semibold mb-2 text-[12px]">
              Persentase Penilaian yang Digunakan
            </h3>

            <table className="min-w-[300px] border border-gray-400 text-[12px]">
              <thead className="bg-gray-200">
                <tr>
                  <th className="border border-gray-400 px-3 pb-2 text-left text-[12px]">
                    Jenis Penilaian
                  </th>
                  <th className="border border-gray-400 px-3 pb-2 text-center text-[12px]">
                    Persentase
                  </th>
                </tr>
              </thead>

              <tbody>
                {Object.entries(persen)
                  .filter(
                    ([key, value]) =>
                      !excludedPersenKeys.includes(key) &&
                      typeof value === "number" &&
                      value > 0,
                  )
                  .map(([jenis, nilaiPersen], index) => (
                    <tr key={index}>
                      <td className="border border-gray-400 px-3 pb-2 text-[12px]">
                        {jenis}
                      </td>
                      <td className="border border-gray-400 px-3 pb-2 text-center text-[12px]">
                        {nilaiPersen}%
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="flex justify-between mb-4 text-center px-10 text-[12px]">
          <div className="text-[12px]">
            <div className="text-left inline-block text-[12px]">
              <br />
              <p>Mengetahui</p>
              <p>Kepala Sekolah</p>
              <br />
              <br />
              <br />
              <div className="absolute border-b border-black pb-1 text-[12px]">
                {datakepsek?.[0]?.name}
              </div>
              <br />
              <p className="font-semibold text-[12px] ">
                NIP. {datakepsek?.[0]?.NIP}
              </p>
            </div>
          </div>

          <div className="text-[12px] ">
            <div className="text-left inline-block text-[12px]">
              <p>
                {sekolah?.[0]?.ttDsekolah}, {getTanggalIndonesia()}
              </p>
              <br />
              <p>Guru Mata Pelajaran</p>
              <br />
              <br />
              <br />
              <div className="absolute border-b border-black pb-1 text-[12px]">
                {user?.name}
              </div>
              <br />
              <p className="font-semibold text-[12px]">NIP. {user?.NIP}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex  justify-between">
        <div>
          {tabelVisible && (
            <button
              onClick={handleDeleteData}
              className="mt-4 py-2 px-4 bg-red-500 text-white rounded hover:bg-red-700"
            >
              Hapus Data
            </button>
          )}
        </div>
        <div>
          {tabelVisible && (
            <button
              onClick={handleSubmit}
              className="mt-4 ml-4 py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-700"
            >
              Submit
            </button>
          )}
          {tabelVisible && (
            <button
              onClick={handleDownloadPDF}
              className="mt-4 ml-4 py-2 px-4 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Download PDF
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default JumlahNilai;
